import Vue from 'vue'
import Router from 'vue-router'

//  pc端页面导入
import Home from '@/views/pc/Home'
import About from '@/views/pc/About'
import Contact from '@/views/pc/Contact'
import Cases from '@/views/pc/Cases'
import CaseDetail from '@/views/pc/CaseDetail'
import JoinUs from '@/views/pc/JoinUs'
import News from '@/views/pc/News'
import NewsDetail from '@/views/pc/NewsDetail'
import Product from '@/views/pc/Product'
import CraftProduct from '@/views/pc/CraftProduct'
import FiveG from '@/views/pc/fiveG'
import WisdomMarket from '@/views/pc/WisdomMarket'
import freeMarket from '@/views/pc/FreeMarket'
import solution from "@/views/pc/solution"
import Custom from "@/views/pc/Custom"
import Service from "@/views/pc/Service"
import FAfinancing from "@/views/pc/FAfinancing"
import AdPutting from '@/views/pc/AdPutting'

const Teamwork = () => import('@/views/pc/Teamwork.vue')



//手机端页面导入
import m_Home from '@/views/mobile/Home'
import m_About from '@/views/mobile/About'
import m_Contact from '@/views/mobile/Contact'
import m_JoinUs from '@/views/mobile/JoinUs'
import m_Job from '@/views/mobile/Job'
import m_News from '@/views/mobile/News'
import m_NewsDetail from '@/views/mobile/NewsDetail'
import m_Cases from '@/views/mobile/Cases'
import m_CaseDetail from '@/views/mobile/CaseDetail'
import m_Product from '@/views/mobile/Product'
import m_cooperation from '@/views/mobile/cooperation'
import m_solutionProramme from '@/views/mobile/solutionProramme'
import m_custom from '@/views/mobile/Custom'
import m_service from '@/views/mobile/Service'
import m_solution from '@/views/mobile/Solution'
import m_CraftProduct from '@/views/mobile/CraftProduct'
import m_wisdomMarket from '@/views/mobile/WisdomMarket'
import m_fiveG from "@/views/mobile/FiveG"
import m_freeMarket from "@/views/mobile/freeMarket"
import m_itAdvisory from "@/views/mobile/itAdvisory"
import m_FaFinancing from "@/views/mobile/FaFinancing"
import m_AdPutting from '@/views/mobile/AdPutting'




Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  window.scrollTo(0, 0);
  return originalPush.call(this, location).catch(err => err)
};

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },

    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/Cases',
      name: 'Cases',
      meta: { keepAlive: true },
      component: Cases
    },
    {
      path: '/CaseDetail/:id',
      name: 'CaseDetail',
      component: CaseDetail,
      meta: { keepAlive: false }
    },
    {
      path: '/joinUs',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/news',
      name: 'News',
      component: News
    },
    {
      path: '/solution/:type',
      name: 'solution',
      component: solution
    },
    {
      path: '/newsdetail/:id',
      name: 'newsdetail',
      component: NewsDetail,
      meta: { keepAlive: false }
    },
    {
      path: '/craftProduct',
      name: 'craftProduct',
      component: CraftProduct
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/five_g',
      name: 'fiveG',
      component: FiveG
    }, {
      path: '/wisdomMarket/:type',
      name: 'wisdomMarket',
      component: WisdomMarket
    }, {
      path: '/freeMarket',
      name: 'freeMarket',
      component: freeMarket
    },
    {
      path: '/custom',
      name: 'custom',
      component: Custom,
    }, {
      path: '/service',
      name: 'service',
      component: Service,
    }, {
      path: '/teamwork',
      name: 'teamwork',
      component: Teamwork,
    }, {
      path: '/FAfinancing',
      name: 'FAfinancing',
      component: FAfinancing,
    }, {
      path: '/AdPutting',
      name: 'AdPutting',
      component: AdPutting,
    },
    

    //    手机端
    {
      path: '/m_about',
      name: 'm_About',
      component: m_About
    },
    {
      path: '/m_contact',
      name: 'm_Contact',
      component: m_Contact
    },
    {
      path: '/m_JoinUs',
      name: 'm_JoinUs',
      component: m_JoinUs
    },
    {
      path: '/m_job/:id',
      name: 'm_job',
      component: m_Job
    },
    {
      path: '/m_newsdetail/:id',
      name: 'm_newsdetail',
      component: m_NewsDetail,
      meta: { keepAlive: false }
    },
    {
      path: '/m_news',
      name: 'm_news',
      component: m_News
    },
    {
      path: '/m_cases',
      name: 'm_cases',
      component: m_Cases
    },
    {
      path: '/m_casedetail/:id',
      name: 'm_casedetail',
      component: m_CaseDetail,
      meta: { keepAlive: false }
    },
    {
      path: '/m_cooperation',
      name: 'm_cooperation',
      component: m_cooperation,
      // meta: { keepAlive: false }
    },
    {
      path: '/m_custom',
      name: 'm_custom',
      component: m_custom,
    },
    {
      path: '/m_service',
      name: 'm_service',
      component: m_service,
    },
     {
      path: '/m_solution/:type',
      name: 'm_solution',
      component: m_solution
    }, 
    {
      path: '/m_solutionProramme/:type',
      name: 'm_solutionProramme',
      component: m_solutionProramme
    },
    {
      path: '/m_craftproduct',
      name: 'm_craftproduct',
      component: m_CraftProduct
    },{
      path: '/m_wisdomMarket/:type',
      name: 'm_wisdomMarket',
      component: m_wisdomMarket
    },{
      path:'/m_fiveG',
      name:'m_fiveG',
      component:m_fiveG
    },{
      path:'/m_freeMarket',
      name:'m_freeMarket',
      component:m_freeMarket
    },{
      path:'/m_itAdvisory',
      name:'m_itAdvisory',
      component:m_itAdvisory
    },{
      path:'/m_FaFinancing',
      name:'m_FaFinancing',
      component:m_FaFinancing
    },
    {
      path:'/m_AdPutting',
      name:'m_AdPutting',
      component:m_AdPutting
    }
    

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js